import { useSwrFetch } from "./useSwrFetch";

interface UseTfcProps {
  shipmentId: number | null;
}

export function useTfc(props: UseTfcProps) {
  const { shipmentId } = props;

  const { data, loading, error, refetch, mutate } = useSwrFetch<TfcResponse>({
    url: shipmentId ? `/shipments/${shipmentId}/tfc` : null,
    errorMessage: "Failed to load Total Freight Cost data.",
  });

  return {
    data,
    loading,
    error,
    refetch,
    mutate,
  };
}
